<template>
    <div class="subpageRoot">
        <!-- <div class="title">{{ t("apiDocumentTitle") }}</div> -->
        <div class="phaseTitle">{{ t('documentBasicInfoTitle') }}</div>
        <div class="documentBasicInfo">
            <ul>
                <li>{{ t('apiUrlTitle') }}:<span v-text="`{{url}}/index/random/details`" class="highlightText"></span></li>
                <li>{{ t('httpMethodTitle') }}:<span class="highlightText">POST</span></li>
                <li>{{ t('contentTypeTitle') }}:<span class="highlightText">application/json</span></li>
            </ul>
        </div>
        <div class="phaseTitle">{{ t('requestArgumentTitle') }}</div>
        <!-- <div class="desText">{{ t('argumentTitleDes') }}</div> -->
        <div class="tableTitle">{{ t('headerArgumentTitle') }}</div>
        <table class="requestArugumentTable">
            <tbody>
                <tr>
                    <th>{{ t('arugumentName') }}</th>
                    <th>{{ t('exampleValueName') }}</th>
                    <th>{{ t('required') }}</th>
                    <th>{{ t('argumentType') }}</th>
                    <th>{{ t('argumentDescription') }}</th>
                </tr>
                <tr>
                    <td>x-token</td>
                    <td>d9b522fcd1f0f2c0e83f51991d93ac3e1c74a6b1e550e40ae70b0976500d50d8</td>
                    <td>{{ t('true') }}</td>
                    <td>String</td>
                    <td>{{ t('token') }}</td>
                </tr>
            </tbody>
        </table>

        <div class="tableTitle">{{ t('bodyArgumentTitle') }}</div>
        <div class="tableTitle highlightText">
            { "addtime": "2021-02-06 10:15:00", "pulse_index": 3, "source_id": 1 }
        </div>
        <table class="requestArugumentTable">
            <tbody>
                <tr>
                    <th>{{ t('arugumentName') }}</th>
                    <th>{{ t('exampleValueName') }}</th>
                    <th>{{ t('required') }}</th>
                    <th>{{ t('argumentType') }}</th>
                    <th>{{ t('argumentDescription') }}</th>
                </tr>
                <tr>
                    <td>pulse_index</td>
                    <td>3</td>
                    <td>{{ t('false') }}</td>
                    <td>Number</td>
                    <td>{{ t('pulseIndexArgumentDes') }}</td>
                </tr>
                <tr>
                    <td>addtime</td>
                    <td>2023-11-11 12:00:00</td>
                    <td>{{ t('false') }}</td>
                    <td>Number</td>
                    <td>{{ t('addBjTimeArgumentDes') }}</td>
                </tr>
                <tr>
                    <td>source_id</td>
                    <td>1</td>
                    <td>{{ t('true') }}</td>
                    <td>Number</td>
                    <td>{{ t('dataSourceArgumentDes') }}</td>
                </tr>
            </tbody>
        </table>

        <div class="phaseTitle">
            <span>{{ t('responseSample') }}</span>
            <el-link @click="downloadResponseCode" class="downloadLink">{{ t('downloadCodeTitle') }}<i
                    class="el-icon-download el-icon--right"></i>
            </el-link>
        </div>
        <!-- <div id="responseSampleEditor" style="height: 800px;"></div> -->
        <el-image class="previewImage"
            :preview-src-list="['https://randomnessbeacon.oss-cn-shanghai.aliyuncs.com/randomdata/img/details.png']"
            src="https://randomnessbeacon.oss-cn-shanghai.aliyuncs.com/randomdata/img/details.png" alt="/"></el-image>

        <div class="phaseTitle">
            <span>{{ t('verifyRandomCodeSampleTitle') }}</span>
            <el-link @click="downloadCurrentSampleCode" class="downloadLink">{{ t('downloadCodeTitle') }}<i
                    class="el-icon-download el-icon--right"></i>
            </el-link>
        </div>
        <div class="tabsContainer">
            <el-tabs type="border-card" v-model="currentLanguage">
                <el-tab-pane v-for="(item, index) in languageList" :key="index" :label="item" :name="item">
                    <!-- <div :id="`monacoEditer_${index}`" style="height: 600px;"></div> -->
                    <el-image :src="languagePreviewImageUrlList[index]"
                        :preview-src-list="[languagePreviewImageUrlList[index]]" class="previewImage"></el-image>
                </el-tab-pane>
            </el-tabs>
        </div>

        <div class="phaseTitle">{{ t('responseArgumentTableTitle') }}</div>
        <table class="responseArugumentTable">
            <tbody>
                <tr>
                    <th>{{ t('arugumentName') }}</th>
                    <th>{{ t('exampleValueName') }}</th>
                    <th>{{ t('argumentType') }}</th>
                    <th>{{ t('argumentDesTitle') }}</th>
                </tr>
                <tr v-for="(item, index) in tableParameters" :key="index">
                    <td>{{ item.name }}</td>
                    <td>{{ item.example }}</td>
                    <td v-if="globalLanguage == 'zh'">{{ item.zh_describe }}</td>
                    <td v-else>{{ item.eh_describe }}</td>
                    <td>{{ item.type }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    name: "apiDocument",
    data() {
        return {
            tableParameters: [],
            languageList: ['php', 'java'],
            languagePreviewImageUrlList: ['https://randomnessbeacon.oss-cn-shanghai.aliyuncs.com/randomdata/img/phpdemo.png', 'https://randomnessbeacon.oss-cn-shanghai.aliyuncs.com/randomdata/img/javademo.png'],
            currentLanguage: 'php',
            globalLanguage: "",
            responseSampleCode: `
{
	"code": "0",
	"msg": "成功",
	"data": {
		"id": 1336417,
		"url": "https://www.randomnessbeacon.com/Jinan/beacon/1.1/chain/1/pulse/477743",
		"version": "1.1",
		"cipher_suite": 0,
		"cipher_suite_pqc": 1,
		"period": 60000,
		"certificate_id": "cb38fb7575abf61d36c2c30b88e6c8f2c85dcb8fdfe49ea12b3d682532b144f996c64a9f3eb413d76da3dde77316e643cf58d76dc6d038d1c6cd70bd34da9a5c",
		"chain_index": 1,
		"pulse_index": 477743,
		"timestamp": "2025-01-18 00:04:00",
		"local_random_value": "c5a1becbbd44db049a93904099f472609888b64f4cc206f98289314b18a6e479ebf86f0b3707a5a38a0d7c09d2a3f8739f731a6b41a67485d03200c672aacdc6",
		"external_source_id": "0",
		"external_status_code": 0,
		"external_value": "0",
		"previous": "5c3abe771d49b55bd94e5cfe814825f9d583debc52e27df5e9c218bfa606d1e38a29239a036cd93a7cc7638c3f25183a01cb9088ee709c9e8c60b56abf6a5f83",
		"hour": "0f409034bbb339cbf69845fee4705dac07de813eef063a3099c80379dc0a0e148c8683915c0f09f9b6099c7dbfe9f5cf13853eca52bc468a7a01a32d2e4e65cb",
		"day": "0f409034bbb339cbf69845fee4705dac07de813eef063a3099c80379dc0a0e148c8683915c0f09f9b6099c7dbfe9f5cf13853eca52bc468a7a01a32d2e4e65cb",
		"month": "981cc5b52f43f041d7d12c852ede6b9315f5322f67faf6e3b331e03f07be36aee1f972c44612c2bf017f5c02298762e78e80fc8dd11e99271b0c9a11fe588214",
		"year": "981cc5b52f43f041d7d12c852ede6b9315f5322f67faf6e3b331e03f07be36aee1f972c44612c2bf017f5c02298762e78e80fc8dd11e99271b0c9a11fe588214",
		"precommitment_value": "536a035280bc5b8128e02073d18b0d9dbc00fd728a69494f7d61930d1397a3f67c5ee2d85133d5e95a1ffa45e1d7eef26eb2d4a555ac6c51d4be69200a8606ac",
		"status_code": 0,
		"signature_rsa": "kGJ3mb2uUHH4kKIOlF8lsI4r7jaZolHS+Z5s1FYFhdIards8Tkn4+9d/v14Wk4Sd4MZ3PyZu5LwGWgt92ugl1zB7/3+Na75I9O5zUSZFNRrPbjnzpfUXyvzfJc7a/yqHvJIFKWyffhAcnJNL+BYEkwpzkYoT2Ul5DzRyiEMYdNkqjMLA5CV5h8dbfOKBTruHKE6NT0MJQ1dpGeTdgoYXrPnE8/KMPMqz8ysbjDvJ1Kk4H4n65xHrv7IadY5Q/o0Lwmo6XZJXAV7RubTfR8NMtF9SgLZJ03NiWi73g2GSmpuv4rOJg/3x0BOJD9mwQ+lWmMvsmDSKexb9Zw6/SPTY+X0bIhePVJlEiKlY6fkQqbGxhwzhrjfzjhrxVT9qY8C0x1j6b+WheA6BJTphwdVkEBIYRL+flrkNX9A6NbHWmV7fYCR5TQPoeMxsIBxH3gfrcvI8xXMzix0fuxOaXJu1JN4A2GnRqjz2/QUH+75KJrzf/YGJBnzST6Pk+kKe8Gksxa2KL4jnNJjUJwr36Bg+G/D4GfYzfIxIS2tg5imfCqy1v4F+BB9eb0l4sgmwE07VqxBQy6vtNkpggziKkLDe5yGdjrOHEdLIVrb8waj8+fJFST4NBzn4gB7ZIojL85Kdri4RFIlCPNAoSO4Ru+vPdOf/3Qn3xRSvOXxsblpFjxM=",
		"output_value_rsa": "d251fbbcb0ddbcaf36d5618e972c70f663fd3e1d0525eb38e7bffdead1fa4ebe51808e8e30b01e3b3a02ac58130b0e6c2752dd06cfceeab6fe81e5899690f42b",
		"original": "fbd765e56f3b435f8c7cd3f8e802990bcba1d64c96677fada3fa0507c8dc8345218196bfc540549597227ca78eac7853a1305cf58c22b15bf8dabfd60a53a623",
		"type": "DI QRNG",
		"chsh": "2.0176999568939",
		"method": "QPE",
		"nist_test": "Pass",
		"previous_pqc": "0d7df1bf0368437d2cd6c83044953400535d6e90d79c6cce4b4cd6e86dbcb5082ab485c088fe23440b2f864576b93107bb55f3aaddb1eaac333914467fe5f045",
		"hour_pqc": "d163a770782b7c981b4f5470f7936f66fa836b2dad19f3dfdaffd56b19e1cf716141d85cd000dfeec0518dc5b42172b599b135fc33758e052a57df84ffc9a4bf",
		"day_pqc": "d163a770782b7c981b4f5470f7936f66fa836b2dad19f3dfdaffd56b19e1cf716141d85cd000dfeec0518dc5b42172b599b135fc33758e052a57df84ffc9a4bf",
		"month_pqc": "addfe28bdf3d9f280e5ad3df6ebeea8d55223314b7905fbe56100c66e78aa16e10feb37aef1a7d22f20a2fe147a200cf8117679c3b1d119485bf43ac75b32e70",
		"year_pqc": "addfe28bdf3d9f280e5ad3df6ebeea8d55223314b7905fbe56100c66e78aa16e10feb37aef1a7d22f20a2fe147a200cf8117679c3b1d119485bf43ac75b32e70",
		"signature_pqc": "LyltlUZeofgIynHoBHfxus0bUcKTpLgnSc9ifONVurs8ikbsZmAHntn7wBVYOY0Sy8QC9awjiU7Ww1+DTPLRp2IRZuXcg50LTAUGvLPQEp2dagpD5ENoL28yNj59006bsZUa/bwaqW2zU5NKbc7L6fZX0QpuesEamd55I7KTJ1lUjrdJhfv8RSVK90Fflh5Q6NdeR+w2AFPJ7KaIB7hgKbGVGv28Gqlts1OTSm3Oy+n2V9EKbnrBGpneeSOykydZasrp1DQstOPRyGTzy5NZ67bNSjv6CGxFUPYyebAZmZuWIoRib744Ra9faUJC23P9uQapIFRMrRCw+v6ofgBaCxXZ+ZZ7MdFdEFL9nS6SuRrq2W6ukg4GB7a2YegNAJhi63Krg5gN3rsTAlTyK6dJDo1dvYqBGtSFNpW2CUISRXZqyunUNCy049HIZPPLk1nrts1KO/oIbEVQ9jJ5sBmZm/2lsKrDo8fH/aWwqsOjx8f9pbCqw6PHx/2lsKrDo8fHsZUa/bwaqW2zU5NKbc7L6fZX0QpuesEamd55I7KTJ1kDEjjIKNf+gInLPsJnugo4bl6ByVLa1uHMAeYyD3k3CFSOt0mF+/xFJUr3QV+WHlDo115H7DYAU8nspogHuGAp9aChFbPvj1ufjmzz++RHoOkqqg/SprVQMuvrKcumKTf1oKEVs++PW5+ObPP75Eeg6SqqD9KmtVAy6+spy6YpN/WgoRWz749bn45s8/vkR6DpKqoP0qa1UDLr6ynLpik3PovZBxc6SjZB9PAKXHkfHhdCKRyVBh+q4PN/QFepG9piEWbl3IOdC0wFBryz0BKdnWoKQ+RDaC9vMjY+fdNOm7GVGv28Gqlts1OTSm3Oy+n2V9EKbnrBGpneeSOykydZYhFm5dyDnQtMBQa8s9ASnZ1qCkPkQ2gvbzI2Pn3TTpuWIoRib744Ra9faUJC23P9uQapIFRMrRCw+v6ofgBaC2IRZuXcg50LTAUGvLPQEp2dagpD5ENoL28yNj59006btVTVEp1d+n6YjpJVt/s2e7WsLyuTLD1Lr7Wt6simqNs+i9kHFzpKNkH08ApceR8eF0IpHJUGH6rg839AV6kb2t5ctTqQi3I//jgyzcuqAkDBYij3zeZR8l4CUBo/QTkjO+990qccnDitEK6R3WJAggRNGN5Q8c4uwm0JdIEkgsS2fVb12FuaMx1oNQyOVJFqtZZLYMHsb8QO3Dn30wl32wMSOMgo1/6Aics+wme6CjhuXoHJUtrW4cwB5jIPeTcIFdn5lnsx0V0QUv2dLpK5GurZbq6SDgYHtrZh6A0AmGI7733SpxycOK0QrpHdYkCCBE0Y3lDxzi7CbQl0gSSCxFSOt0mF+/xFJUr3QV+WHlDo115H7DYAU8nspogHuGAp++31oueO8pcEgiOkT0CcC172QUZAVGwqafQCL0cwzA/9pbCqw6PHx/2lsKrDo8fH/aWwqsOjx8f9pbCqw6PHx/WgoRWz749bn45s8/vkR6DpKqoP0qa1UDLr6ynLpik3PovZBxc6SjZB9PAKXHkfHhdCKRyVBh+q4PN/QFepG9q1VNUSnV36fpiOklW3+zZ7tawvK5MsPUuvta3qyKao295ctTqQi3I//jgyzcuqAkDBYij3zeZR8l4CUBo/QTkjsZUa/bwaqW2zU5NKbc7L6fZX0QpuesEamd55I7KTJ1mxlRr9vBqpbbNTk0ptzsvp9lfRCm56wRqZ3nkjspMnWRXZ+ZZ7MdFdEFL9nS6SuRrq2W6ukg4GB7a2YegNAJhisZUa/bwaqW2zU5NKbc7L6fZX0QpuesEamd55I7KTJ1m1VNUSnV36fpiOklW3+zZ7tawvK5MsPUuvta3qyKao2/vt9aLnjvKXBIIjpE9AnAte9kFGQFRsKmn0Ai9HMMwPFdn5lnsx0V0QUv2dLpK5GurZbq6SDgYHtrZh6A0AmGKxlRr9vBqpbbNTk0ptzsvp9lfRCm56wRqZ3nkjspMnWWIRZuXcg50LTAUGvLPQEp2dagpD5ENoL28yNj59006b9aChFbPvj1ufjmzz++RHoOkqqg/SprVQMuvrKcumKTfrcquDmA3euxMCVPIrp0kOjV29ioEa1IU2lbYJQhJFdutyq4OYDd67EwJU8iunSQ6NXb2KgRrUhTaVtglCEkV2tVTVEp1d+n6YjpJVt/s2e7WsLyuTLD1Lr7Wt6simqNv9pbCqw6PHx/2lsKrDo8fH/aWwqsOjx8f9pbCqw6PHxzvvfdKnHJw4rRCukd1iQIIETRjeUPHOLsJtCXSBJILEsZUa/bwaqW2zU5NKbc7L6fZX0QpuesEamd55I7KTJ1k+i9kHFzpKNkH08ApceR8eF0IpHJUGH6rg839AV6kb2rVU1RKdXfp+mI6SVbf7Nnu1rC8rkyw9S6+1rerIpqjbtVTVEp1d+n6YjpJVt/s2e7WsLyuTLD1Lr7Wt6simqNtUjrdJhfv8RSVK90Fflh5Q6NdeR+w2AFPJ7KaIB7hgKbVU1RKdXfp+mI6SVbf7Nnu1rC8rkyw9S6+1rerIpqjbVI63SYX7/EUlSvdBX5YeUOjXXkfsNgBTyeymiAe4YCkV2fmWezHRXRBS/Z0ukrka6tlurpIOBge2tmHoDQCYYvWgoRWz749bn45s8/vkR6DpKqoP0qa1UDLr6ynLpik3liKEYm++OEWvX2lCQttz/bkGqSBUTK0QsPr+qH4AWgtiEWbl3IOdC0wFBryz0BKdnWoKQ+RDaC9vMjY+fdNOmzvvfdKnHJw4rRCukd1iQIIETRjeUPHOLsJtCXSBJILEtssRu+HKKjkWWozG0ZdC6kmhXy6DuQBULNX0MV5GpAWYnWTa8BjWRT2NQSqvfb6wCD45gNhLG45QIyYTWJsSNMMiRJW7E8KHzZYq940l1x3IcLg+99eIx54O/cgA1AevV+or2J2P77wQzxRE2fOf09x+Bei8amy5aJqEVTI27TYbpu9U42hQoXsJFk5cRoq+lv18Yh/5XAfV0dAAB9MGDuG4npYBYQWTIIJNFBtGsCftYRl8aTiSHBos8xJu2KzDqsZPM/ZRrhHHgo/ZkH2TfiIrZalv/OZznV5f9PaDpocbpu9U42hQoXsJFk5cRoq+lv18Yh/5XAfV0dAAB9MGDuG4npYBYQWTIIJNFBtGsCftYRl8aTiSHBos8xJu2KzDPWr8kaduA/rXg6BbAhXIpBF10QOpCEJVQsXXQF4YWBA9avyRp24D+teDoFsCFcikEXXRA6kIQlVCxddAXhhYED1q/JGnbgP614OgWwIVyKQRddEDqQhCVULF10BeGFgQMQFJW42uWHmmWet+XynbYD23rhNNwuKKlNoUE65EE6nDIkSVuxPCh82WKveNJdcdyHC4PvfXiMeeDv3IANQHr+rZLhBrBzVkrSLy4GQGbgPMWcI/jgNT91tdnm9+fV6Gnxouc2d83G+9875H+nCw0st1liM9oOQkGyaoOI5RREKqxk8z9lGuEceCj9mQfZN+IitlqW/85nOdXl/09oOmh58aLnNnfNxvvfO+R/pwsNLLdZYjPaDkJBsmqDiOUURCwyJElbsTwofNlir3jSXXHchwuD7314jHng79yADUB6+rLEIAk4av8krWvzfk1ncsWDmeRndrZGe7dMJveuJ8YzEBSVuNrlh5plnrfl8p22A9t64TTcLiipTaFBOuRBOpqsZPM/ZRrhHHgo/ZkH2TfiIrZalv/OZznV5f9PaDpoefGi5zZ3zcb73zvkf6cLDSy3WWIz2g5CQbJqg4jlFEQjEBSVuNrlh5plnrfl8p22A9t64TTcLiipTaFBOuRBOpV+or2J2P77wQzxRE2fOf09x+Bei8amy5aJqEVTI27TafGi5zZ3zcb73zvkf6cLDSy3WWIz2g5CQbJqg4jlFEQqrGTzP2Ua4Rx4KP2ZB9k34iK2Wpb/zmc51eX/T2g6aHV+or2J2P77wQzxRE2fOf09x+Bei8amy5aJqEVTI27TZX6ivYnY/vvBDPFETZ85/T3H4F6LxqbLlomoRVMjbtNn7G7f4tqP3adav95xr59LuMIilMrBiZ5wRapQJxO3ia",
		"output_value_pqc": "6f5507c35ba9ce8fa4dd4eeef1c240979cf765c4ffb22b9ab25fe34b77bc76268199c5ba7f213cf60bbd11935e0045426c42c45e76541627c6c9e5dd37453ad6",
		"certificate_id_pqc": "8ccde9edeed43ed232172c10c881582e95b6a157d5479d3ffa5af245c8796fcf494e52121d528e1d79ddaaf855831bcec2ab66e6647b62fd9bcf01e50d349d36",
		"addtime": 1737129840,
		"signature_pqc_url": "https://randomnessbeacon.oss-cn-shanghai.aliyuncs.com/randomdata/jinan_random/2025/01/18/sign1737158593.txt",
		"synchro_url": "https://randomnessbeacon.oss-cn-shanghai.aliyuncs.com/randomdata/synchro_jinan_random/2025/01/18/1336417.txt"
	}
}
            `,
            languageCode: {
                'php': `
<?php
declare (strict_types=1);
            
class demo
{
    private $priKeyPath = '';
    private $cacertPath = '';
    private $pqccacertPath = '';
 
    public function __construct(array $data = [])
    {
        $this->cacertPath = public_path() . 'static/pem/cacert.pem';
        $this->pqccacertPath = public_path() . 'aigis/alice.pk';
    }
 
    public function rsa()
    {
       $signature_value = "Fqvhq5r6+UiinDTB2VIX8I7v1NsqEPLHWLiVYF/43UsfQ7CkTYfKBOtMZs0YpiMtxMox5CWi0yu2x9BvoF0J+e2hd8olmxUg9jCbQ3nOrOdxQEUBntT4Z/ld/oMdB4MEGl7NM1vy6v1DRc0SgoYgY6FGM+oA8guTDwKrdDeG+en3l+oX/1FmvJzon7+B/zP6uNB91fNv4dr/dIJPbjNZWPv5QakokHTYs8nOsT1O0DwUuQtrVYANWe5nvkBBzR9TwnFtMCzkqtkB8tQD1VYcjJqZTLZa4JcL7QSBv6lvjGdOnaty+/eut/Sbm9ZsZ4fnVkIM/7jzg6Vrt1JFkiCJDd7MgMbYnfKvDHYDG6FOOkksZlG+ng8prkchHavw6mP31n53VWdaL3cuwVMABs9YpL/kbz+hpYCR+wsxCfTXGqG9I6oGYT6+Ek8cUzzTKtWS6dRHOlHMQ7ERjvukqCjzw2mBYx6qFo5Y09pDlALRcqZn8MD+KZNZ4AY9Nuv6qJyjrTpmCanGBKCHAFtTFoCzVjz1PYUeZBsFqqA25U1IDjepfJk3q9LGSTYV8VWaaLWdDJjhtllb5YlO9eph1wbbbeRL9GbSz/h6xqOwiySChBVnyKRxEQ9zcFPc9l+pO/EMfHJ83wm/qNqMpfl0LUQYs5MLRw956FLW0USY9iFA9Ao="; 
        $value = base64_decode($signature_value);
        $publicKey = openssl_pkey_get_public(file_get_contents($this->cacertPath));
        $isValid = openssl_public_decrypt( $value,$sign, $publicKey, OPENSSL_PKCS1_PADDING);
    }
 
    public function pqc()
    {
        exec('cd aigis && .\aigis.exe verify ./alice.pk ./data/randomData.txt ./data/sign.txt',$out);
    }
}`,
                'java': `
package com.moye99;
import cn.hutool.core.codec.Base64;
import cn.hutool.crypto.PemUtil;
import cn.hutool.crypto.asymmetric.KeyType;
import cn.hutool.crypto.asymmetric.RSA;

import java.io.InputStream;
import java.security.PublicKey;

public class Test {
    public static void main(String[] args) {
        InputStream inputStream = RSAUtils.class.getClassLoader().getResourceAsStream("cacert.pem");
        PublicKey publicKey = PemUtil.readPemPublicKey(inputStream);
        System.out.println("公钥:" + publicKey);
        String sign = "Fqvhq5r6+UiinDTB2VIX8I7v1NsqEPLHWLiVYF/43UsfQ7CkTYfKBOtMZs0YpiMtxMox5CWi0yu2x9BvoF0J+e2hd8olmxUg9jCbQ3nOrOdxQEUBntT4Z/ld/oMdB4MEGl7NM1vy6v1DRc0SgoYgY6FGM+oA8guTDwKrdDeG+en3l+oX/1FmvJzon7+B/zP6uNB91fNv4dr/dIJPbjNZWPv5QakokHTYs8nOsT1O0DwUuQtrVYANWe5nvkBBzR9TwnFtMCzkqtkB8tQD1VYcjJqZTLZa4JcL7QSBv6lvjGdOnaty+/eut/Sbm9ZsZ4fnVkIM/7jzg6Vrt1JFkiCJDd7MgMbYnfKvDHYDG6FOOkksZlG+ng8prkchHavw6mP31n53VWdaL3cuwVMABs9YpL/kbz+hpYCR+wsxCfTXGqG9I6oGYT6+Ek8cUzzTKtWS6dRHOlHMQ7ERjvukqCjzw2mBYx6qFo5Y09pDlALRcqZn8MD+KZNZ4AY9Nuv6qJyjrTpmCanGBKCHAFtTFoCzVjz1PYUeZBsFqqA25U1IDjepfJk3q9LGSTYV8VWaaLWdDJjhtllb5YlO9eph1wbbbeRL9GbSz/h6xqOwiySChBVnyKRxEQ9zcFPc9l+pO/EMfHJ83wm/qNqMpfl0LUQYs5MLRw956FLW0USY9iFA9Ao=";
        System.out.println(check(sign, publicKey));
    }
    private static boolean check(String sign, PublicKey publicKey) {
        byte[] decode = Base64.decode(sign);
        RSA rsa = new RSA(null, publicKey);
        byte[] decrypt = new byte[0];
        try {
            decrypt = rsa.decrypt(decode, KeyType.PublicKey);
        } catch (Exception e) {
            throw new RuntimeException("验签失败！！！");
        }
        return decrypt.length != 0;
    }
}`,
            }
        }
    },
    methods: {
        t(key) {
            return this.$t(`apiDocument.${key}`);
        },
        downloadResponseCode() {
            const blob = new Blob([this.responseSampleCode], { type: 'text/plain;charset=utf-8' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'responseCode.txt';
            a.click();
            window.URL.revokeObjectURL(url);
        },
        downloadCurrentSampleCode() {
            const blob = new Blob([this.languageCode[this.currentLanguage]], { type: 'text/plain;charset=utf-8' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `${this.currentLanguage}.txt`;
            a.click();
            window.URL.revokeObjectURL(url);
        },
    },
    async created() {
        const tableParametersRes = await this.$post("/index/random/apidescription")
        this.tableParameters = tableParametersRes.data;

        setInterval(() => {
            this.globalLanguage = window.localStorage.getItem('locale');
        }, 100);
    },
}
</script>


<style lang="scss" scoped>
@import "../main.scss";

.subpageRoot {
    width: 100%;

    .highlightText {
        @include border-box-padding(1px 6px);
        background-color: rgb(247, 247, 247);
        color: $theme-color;
        font-size: 15px;
        margin-left: 4px;
    }

    .phaseTitle {
        @include border-box-padding(2px 0 2px 4px);
        @include flex-row-center-start;
        width: 100%;
        border-left: 5px solid $theme-color;
        margin: 10px 0;
        font-size: 17px;
        font-weight: bold;
    }

    .previewImage {
        width: 100%;
        height: auto;
        cursor: pointer;
    }

    .downloadLink {
        margin-left: 10px;
    }

    .documentBasicInfo {
        @include border-box-padding(0 0 0 30px);
        width: 100%;

        &>ul>li {
            margin: 8px 0;
            font-size: 17px;
            font-weight: bold;
        }
    }

    .desText {
        margin: 10px 0;
        color: $des-color;
        font-size: 15px;
    }

    .tableTitle {
        margin: 10px 0;
    }

    .tableCellBase {
        @include border-box-padding(6px 15px);
        border: 1px solid #93c8ff;
        border-collapse: collapse;
        border-spacing: 0;
        background-color: #f5fbff;
        color: $theme-color;
        text-align: left;
        font-size: 15px;
        font-weight: normal;
        line-height: 25px;
    }

    .requestArugumentTable {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;
        padding: 5px;

        &>tbody>tr>th {
            width: 20%;
            white-space: nowrap;
        }

        &>tbody>tr>th:first-child {
            width: 15%;
        }

        &>tbody>tr>th:nth-child(2) {
            width: 30%;
        }

        &>tbody>tr>th:nth-child(3),
        &>tbody>tr>th:nth-child(4) {
            width: 15%;
        }

        &>tbody>tr>th:last-child {
            width: 25%;
        }

        &>tbody>tr>th,
        &>tbody>tr>td {
            @extend .tableCellBase;
            word-break: break-all;
        }

        &>tbody>tr>td:not(:first-child) {
            background-color: white;
        }
    }

    .tabsContainer {
        width: 100%;
    }

    .responseArugumentTable {
        @extend .requestArugumentTable;

        &>tbody>tr>th:first-child {
            width: 10%;
        }

        &>tbody>tr>th:nth-child(4),
        &>tbody>tr>td:nth-child(4) {
            width: 5%;
            text-align: center;
        }
    }
}
</style>